import React, { useEffect } from "react";
import { useAppSelector } from "@/app/hooks";
import {
  selectApiData,
  selectGroupingConfig,
} from "@/features/bughurd/boardSelector";
import { DragDropContext } from "react-beautiful-dnd";
import SubGroupDataGrid from "./SubGroupDataGrid";
import KanbanBoard from "./KanbanBoard";
import { useDragAndDrop } from "./custom-hooks/useDragAndDrop";
import TaskUpdateDrawer from "../bugherdComponents/TaskUpdateDrawer";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

interface KanbanViewProps {
  handleTaskUpdate: (
    taskId: string,
    updatedTask: any | null,
    newColumnId?: string,
  ) => void;
  refreshColumnData: (columnId?: string, subGroupId?: string) => Promise<void>;
  handleLoadMore: (columnId: string, subGroupId?: string) => void;
  isMyTaskView: boolean;
  reactFlow?: any;
}

const KanbanView: React.FC<KanbanViewProps> = ({
  handleTaskUpdate,
  refreshColumnData,
  handleLoadMore,
  isMyTaskView,
  reactFlow,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  // const fromGlobalSearch = searchParams.get("fromGlobalSearch");
  const bugId = searchParams.get("bugId");

  const { task: selectedTask } = useLocation().state || {};
  const { subGroupBy } = useAppSelector(selectGroupingConfig);
  const { companyMemberData } = useAppSelector(selectApiData);

  const { handleDragStart, handleDragEnd } = useDragAndDrop();

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [optimisticTask, setOptimisticTask] = React.useState<any>(null);

  useEffect(() => {
    if (bugId) {
      // setOptimisticTask(selectedTask);
      setIsModalOpen(true);
    }
  }, [bugId]);

  const handleClose = () => {
    setIsModalOpen(false);
    setOptimisticTask(null);

    if (bugId) {
      navigate(location.pathname);
    }
  };

  if (subGroupBy !== "None") {
    return (
      <SubGroupDataGrid
        handleTaskUpdate={handleTaskUpdate}
        refreshColumnData={refreshColumnData}
        handleLoadMore={handleLoadMore}
        isMyTaskView={isMyTaskView}
      />
    );
  }

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
        <KanbanBoard
          handleTaskUpdate={handleTaskUpdate}
          refreshColumnData={refreshColumnData}
          handleLoadMore={handleLoadMore}
          isMyTaskView={isMyTaskView}
          reactFlow={reactFlow}
        />
      </DragDropContext>
      {isModalOpen && (
        <TaskUpdateDrawer
          open={isModalOpen}
          onClose={handleClose}
          setBugId={() => {}}
          setDrawerOpen={() => {}}
          bugId={optimisticTask?._id || bugId}
          users={companyMemberData || []}
          createdBy={optimisticTask?.createdBy?.fullName || ""}
          setCreatedBy={() => {}}
          refreshColumn={refreshColumnData}
          onTaskUpdate={handleTaskUpdate}
          reactFlow={reactFlow}
          // task={optimisticTask}
        />
      )}
    </>
  );
};

export default KanbanView;
